import { render } from "./PointsChecker.vue?vue&type=template&id=af4b05ce"
import script from "./PointsChecker.vue?vue&type=script&lang=js"
export * from "./PointsChecker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__